import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { photoUrl } from "../lib/usePortfolio";

const EASE = [0.22, 1, 0.36, 1];

export default function StoryCard({ story, index = 0, large = false }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: EASE }}
      data-testid={`story-card-${story.slug}`}
      className="group"
    >
      <Link to={`/journal/${story.slug}`} className="block">
        <div className={`relative overflow-hidden bg-surface ${large ? "aspect-[16/10]" : "aspect-[4/5]"}`}>
          {story.cover ? (
            <img src={photoUrl(story.cover)} alt={story.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
          ) : (
            <div className="h-full w-full flex items-center justify-center font-serif italic text-stone-600">No cover yet</div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
          <span className="absolute top-4 left-4 text-[10px] font-mono tracking-[0.25em] uppercase text-champagne">
            {story.date}
          </span>
        </div>
        <div className="mt-5 flex items-start justify-between gap-4">
          <div>
            <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">
              {[story.couple, story.venue].filter(Boolean).join(" — ")}
            </p>
            <h3 className={`mt-2 font-serif text-ivory leading-tight group-hover:text-champagne transition-colors duration-300 ${large ? "text-2xl sm:text-3xl" : "text-xl"}`}>
              {story.title}
            </h3>
            {story.excerpt && <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-stone-400 line-clamp-2">{story.excerpt}</p>}
          </div>
          <ArrowUpRight size={18} className="mt-1 shrink-0 text-stone-500 transition-all duration-300 group-hover:text-champagne group-hover:-translate-y-1 group-hover:translate-x-1" />
        </div>
      </Link>
    </motion.article>
  );
}
